import { createSlice } from '@reduxjs/toolkit'
import { AlbumInsert,photoInsert,videoInsert,MediaGet,albumGet,Updatealbum,MediaDelete,deleteUpdate } from '../api/GalleryApis'

const initialState = {
    media:[],
    album:[],
    loading:false,
}

export const GallerySlice = createSlice({
  name: 'GallerySlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

   
      builder.addCase(AlbumInsert.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(AlbumInsert.fulfilled , (state, action) => {
       
        // state.albums=action.payload; 
       
        state.loading = false;
      })
      builder.addCase(AlbumInsert.rejected, (state, action) => {
        state.loading = false;
      
      })

      // -- photo api Extrareducers

      builder.addCase(photoInsert.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(photoInsert.fulfilled , (state, action) => {
    //    state.photo=action.payload; 
       state.loading = false;
      })
      builder.addCase(photoInsert.rejected, (state, action) => {
        state.loading = false;
      
      })


      builder.addCase(videoInsert.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(videoInsert.fulfilled , (state, action) => {
    //    state.photo=action.payload; 
       state.loading = false;
      })
      builder.addCase(videoInsert.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(MediaGet.pending, (state, action) => {
        state.loading = true;
        state.media = [];
      })
      builder.addCase(MediaGet.fulfilled , (state, action) => {
       state.media=action.payload; 
       state.loading = false;
      })
      builder.addCase(MediaGet.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(MediaDelete.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(MediaDelete.fulfilled , (state, action) => {
      
       state.loading = false;
      })
      builder.addCase(MediaDelete.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(albumGet.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(albumGet.fulfilled , (state, action) => {
       state.album=action.payload; 
       state.loading = false;
      })
      builder.addCase(albumGet.rejected, (state, action) => {
        state.loading = false;
       
      })


      builder.addCase(Updatealbum.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(Updatealbum.fulfilled , (state, action) => {
       state.album=action.payload; 
       state.loading = false;
      })
      builder.addCase(Updatealbum.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(deleteUpdate.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(deleteUpdate.fulfilled , (state, action) => {
       state.album=action.payload; 
       state.loading = false;
      })
      builder.addCase(deleteUpdate.rejected, (state, action) => {
        state.loading = false;
      
      })

      
  },

})



export default GallerySlice.reducer